import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './SSO_Main.html?raw';
import on from 'dojo/on';
import MainProperties from '../../WebCalendar_TS/MainProperties/MainProperties';
import "../../WebCalendar_TS/MainProperties/MainProperties";


import { EvBookingView, EvBookingEditor  } from "../../_loadingHelpers/VAM"
import ProjectReportOptionsForm from '../../ProjectWizard/ProjectReportOptionsForm/ProjectReportOptionsForm';
import { ToasterHelpers } from "../../../more/Helpers";
import { WebcalendarTypes } from "../../../moreCore/UI/moreCoreCalendar/WebCalendarTypes";



class SSO_Main extends compose(_WidgetBaseSP) {
    
    templateString: any = template;

    private mainProperties: MdsLax<InstanceType<typeof MainProperties>>;
    private currentBookingEditor: MdsLax<InstanceType<typeof EvBookingEditor>> = null;
    private bookingEditingEnabledForCurrentUser: boolean = false;

    evBookingEditorSectionsConfig: EvBookingEditor_SectionsConfig = {
        isBookerSectionVisible: false,
        isTicketSectionVisible: true,
        isCastListVisible: true,
        isProgramListVisible: true,
        isEvTasksListVisible: true,
        isServiceListVisible: true,
        isOrchesterEmployementsListVisible: true,
        isEvCategoriesListVisible: true,
        isFilesSectionVisible: true
    };

    private _calendarCreated() {

        on(this.mainProperties.calendar, "viewtypeChange", lang.hitch(this, this._viewtypeChanged));

    }
    _viewtypeChanged(data: any) {
        //console.debug("_viewtypeChanged", data);
    }

    showBookingDetails(item: WebcalendarTypes.WebCalendarItemData_Default): void {

        if (item.Classname == "ev_booking") {
            let additionalData = {
                selectedHtCalendarID: this.mainProperties.getCurrentSelectedCalendar()?.ID
            };

            let view = new EvBookingView();

            view.setup(item.id, item.columnview_head_text, additionalData);
            view.startup();
        } else {

            this.mainProperties.openDefaultDetailView(item); // mal standard aufrufen

            // ... aber erweitern: Daten für den Editor requesten

            let dlg = this.mainProperties.itemClickDlg;

           
        }
    }

    private _onClick_Report(item: WebcalendarTypes.WebCalendarItemData_Default, evt: MouseEvent) {

        this.StandbyStart(this.mainProperties.itemClickDlg.actionContainerNode);

        let url = window.appRoot + "Downloads/ProjectReport";

        if (this.hasFeature("EvProject/ProjectReportOptions") === true) {

            let optionsDlg = new ProjectReportOptionsForm();
            optionsDlg.displayOptionsDialog(item.id, lang.hitch(this, this._sendProjectRequest, url));
            optionsDlg.on("projectreport_cancelled", () => { this.StandbyStop(); });
            return;
        }

        let data = { "bookingID": item.id };
        let stringData = JSON.stringify(data);

        this._sendProjectRequest(url, stringData);
    }

    private _sendProjectRequest(url: string, stringData: string): void {

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onDownloadReady),
            lang.hitch(this, this._onRequestReportError),
            false // sync
        );
    }

    private _onDownloadReady(entity: FileFinder.FileDescriptor) {
        //debugger;
        this.StandbyStop();
        //console.log("_onClick_Download", entity);
        location.href = window.appRoot + this.stringFormat("FileDashboard/Download?downloadKey={0}&fileName={1}.{2}",
            entity.downloadKey,
            entity.filename,
            entity.extension);

    }

    private _onRequestReportError(error: more.requestErrorMessage) {
        this.StandbyStop();
        alert(error.Message);
    }



    private _checkIfBookingEditingEnabledForCurrentUser(): void {
        
        this.hasUserRole(["EvBooking_Create", "EvBooking_Edit"], lang.hitch(this, this._showBookingEditorInterface));
    }

    private _showBookingEditorInterface(bool?: boolean): void {
        //console.log("_showBookingEditorInterface", bool);
        this.bookingEditingEnabledForCurrentUser = bool === true;

        if (this.bookingEditingEnabledForCurrentUser == true) {

            let createBookingBtn = this.UiModder.domConstruct.create("BUTTON", {
                innerHTML: this.translations["WebCalendar_SidebarPane_btnLabel_createBooking"],
                className: "mds-button-base round mds-hover-dark w3-block",
                onclick: lang.hitch(this, this._onclickOpenBookingEditor)
            });

            this.mainProperties.addCustomPane("evBookingEditorPane", this.translations["WebCalendar_SidebarPane_paneLabel_bookingEditor"], createBookingBtn, "fas fa-calendar-plus");

        } else {
            this.mainProperties.removePane("evBookingEditorPane");
        }
    }

    private _setupMainPropertes(): void{

        if (this.mainProperties != null) {
            this.mainProperties.destroy();
            this.mainProperties = null;
        }

        this.mainProperties = new MainProperties();

        on(this.mainProperties, "calendarCreated", lang.hitch(this, this._calendarCreated));
        
        this.UiModder.domConstruct.place(this.mainProperties.domNode, this.domNode, "first");

        let detailFct = lang.hitch(this, this.showBookingDetails);

        this.mainProperties.setMainConfig({
            itemDetails: {
                customItemClickFunction: detailFct
                //requestUrl: 
            },
            userProperties: {
                customFunctionName: "Webtool_API_Webcalendar__GetUserProperties",
                requestUrl: "Calendar/GetUserProperties",
                //requestParams: [{ name: "jsonData", value: { user: "unknown" } }]
            },
            filterData: {
                customFunctionName: "Webtool_API_Webcalendar__GetFilterData"
            },
            defaultDisplaySettings: {
                b_show_end_time: true,
                //hideColumnHead: true
            }
        });
        
        this.mainProperties.startup();

        this._preparePanels();

        // Titel überschreiben, der vom Webkalender gesetzt würde
        //this.mainProperties.setTitles(
        //    this.stringFormat(this.translations["KWittCalendar__MainTitle"], this.translations["MainTitle"]),
        //    this.translations["KWittCalender__Title"]);

    }

    private _preparePanels(): void {
        if (!this.mainProperties) {
            return;
        }

        let props = this.mainProperties;

        //props.addCustomPane(....)

    }

//    private _doubleClickFct(clickedDate: Date) {
//        if (this.bookingEditingEnabledForCurrentUser == true) {
//            this._onclickOpenBookingEditor(null);

//            if (this.currentBookingEditor != null) {
//                this.currentBookingEditor.editorForm.dateStartInput.setValue(clickedDate);
//            }
//        }
//}

    private _onclickOpenBookingEditor(item: WebcalendarTypes.WebCalendarItemData_Default): void {

        if (this.bookingEditingEnabledForCurrentUser == true) {

            if (this.mainProperties.itemClickDlg && this.mainProperties.itemClickDlg._destroyed != true) {
                try {

                    this.mainProperties.itemClickDlg.close();
                } catch (ex) {
                    // nich so schlümm
                }
            };


            if (this.currentBookingEditor != null) {
                if (this.currentBookingEditor._destroyed !== true) this.currentBookingEditor.destroy();
                this.currentBookingEditor = null;
            }

            this.currentBookingEditor = new EvBookingEditor();
            this.currentBookingEditor.setEvBookingEditorConfig(this.evBookingEditorSectionsConfig);

            if (item) {
                this.currentBookingEditor.loadEntityById(item.id);
            }
            this.currentBookingEditor.showBookingEditorForm();

            this.currentBookingEditor.on("saveDataResponse", lang.hitch(this, this._onUpdateItemChanges_Response));
        } else {
            alert("Current User has no permissions for booking editor")
        }
    }

    private _onUpdateItemChanges_Response(response: string) {
        this.mainProperties._onUpdateItemChanges_Response(response);
    }


    publishToastMessage(text: string, icon: ToasterHelpers.ToasterIcons = ToasterHelpers.ToasterIcons.none, timeout?: number, extendedMessage?: string): void {
        if (!this.mainProperties) {
            alert(text);
            console.error(text, extendedMessage);
            return;
        }
        this.mainProperties.publishToastMessage(text, icon, timeout, extendedMessage)
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
        //this._isStartup = true;
        //this._continueWithSession();
        //this._checkUrlParameters();
        this._setupMainPropertes();

        this._checkIfBookingEditingEnabledForCurrentUser();

    }

}

export default mdsWidget(SSO_Main);